var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":_vm.$t('addShooting.selectModel'),"return-object":"","item-value":"id","item-text":"name","items":_vm.filteredModels,"clearable":"","rules":_vm.rules},on:{"input":_vm.update},model:{value:(_vm.selectedModel),callback:function ($$v) {_vm.selectedModel=$$v},expression:"selectedModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }